import { Box, Typography } from '@mui/material';
import { useAsync } from 'react-use';
import { useState } from 'react';
import { CategoriesOptions } from './components/CategoriesOptions';
import { useApi } from '@hooks/useApi';
import { snakeToTitleCase } from '@shared/utils/string';
import { FREEMIUM_CATEGORIES } from './constants';
import { FreemiumCategoryCard } from './components/FreemiumCategoryCard';
import { FreemiumDataResponse } from './types';

export const Freemium = () => {
  const { apiClient } = useApi();
  const [freemiumData, setFreemiumData] = useState<FreemiumDataResponse>([]);
  const [ignored, setEditingField] = useState<string | null>(null);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [fieldsToShow, setFieldsToShow] = useState<string[]>([]);
  const [category, setCategory] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [refreshDataKey, setRefreshDataKey] = useState<number>(0);

  useAsync(async () => {
    const fetchedFreemiumData = await apiClient?.getFreemiumData();
    setFreemiumData(fetchedFreemiumData || []);
  }, [apiClient, refreshDataKey]);

  const handleEditFreemiumData = (title: string) => {
    setCategory(title);
    setTitle(snakeToTitleCase(title));
    setEditingField(title);
    setFieldsToShow(FREEMIUM_CATEGORIES.find(category => category.id === title)?.fields.map(field => field.id) || []);
    setShowForm(true);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center" padding={2}>
      <Box maxWidth="1920px" width="100%" display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center">
        <Box width="100%" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h3" gutterBottom sx={{ marginBottom: '20px' }}>
            Freemium Options
          </Typography>
          {FREEMIUM_CATEGORIES.map(category => (
            <FreemiumCategoryCard
              key={category.id}
              title={category.title}
              fields={category.fields}
              data={freemiumData?.find(item => item.category === category.id)?.data}
              onEdit={() => handleEditFreemiumData(category.id)}
            />
          ))}
          {showForm && (
            <CategoriesOptions
              fieldsToShow={fieldsToShow}
              freemiumData={freemiumData}
              isOpen={showForm}
              onClose={() => setShowForm(false)}
              isPrivateAllowed={false}
              category={category}
              title={title}
              setRefreshDataKey={setRefreshDataKey}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
